import { Injectable } from '@angular/core';
import { CreateNotificationIntegrationRequest } from '../models/requests/create-notification-integration-request';
import { HttpClient } from '@angular/common/http';
import { NotificationResponse } from '../models/responses/notification-response';
import { environment } from '../environments/environments';
import { UpdateNotificationIntegrationRequest } from '../models/requests/update-notification-integration-request';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private httpClient: HttpClient) { }

  create(request: CreateNotificationIntegrationRequest) {
    return this.httpClient.post<NotificationResponse>(`${environment.notificationIntegrationUrl}`,request)
  }
  update(request:UpdateNotificationIntegrationRequest){
    return this.httpClient.put<NotificationResponse>(`${environment.notificationIntegrationUrl}`,request);
  }
  delete(id:number){
    return this.httpClient.delete<NotificationResponse>(`${environment.notificationIntegrationUrl}/${id}`);
  }
}
